module.exports = "/menu/get-sling-app-7b36cc.html";